@import 'styles/blaze/mixins';
@import 'styles/mixins';

.container {
  align-items: center;
  display: flex;
  gap: 10px;
}

.trialDaysLeft {
  align-items: flex-end;
  display: flex;
  gap: 4px;
}

.button {
  align-items: center;
  background: linear-gradient(270deg, rgba(182, 75, 248, 0.2) 0%, rgba(1, 121, 207, 0.2) 100%), var(--default-bg);
  border-radius: 999px;
  display: flex;
  gap: 2px;
  padding: 10px;

  [data-autopilot-system-redesign='on'] & {
    padding: 8px;
  }

  &:hover {
    cursor: pointer;
    background: linear-gradient(0deg, var(--Dark-8, rgba(0, 0, 0, 0.08)) 0%, var(--Dark-8, rgba(0, 0, 0, 0.08)) 100%),
      linear-gradient(
        270deg,
        var(--Magenta-50, rgba(182, 75, 248, 0.2)) 0%,
        var(--Blue-70, rgba(1, 121, 207, 0.2)) 100%
      ),
      var(--background, #ddeffc);
  }
}

.textContainer {
  color: var(--purple-70);
  padding: 0px 6px 2px 6px;

  [data-autopilot-system-redesign='on'] & {
    padding: 0px 4px 2px 4px;
    display: flex;
    align-items: center;

    span {
      @include xs-sohne-medium;
    }
  }

  span {
    @include sm-sohne-medium;
    line-height: 115%; /* 16.1px */
  }
}
